'use client'

import { Icon, Image } from '@vinted/web-ui'
import { ArrowRight16 } from '@vinted/monochrome-icons'

import { useIsDarkMode } from '@marketplace-web/dark-mode/dark-mode-feature'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { clickEvent } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'

import { ValuePerpositionCardModel } from './types'
import { IMAGE_BASE_URL } from '../../../constants'

const Card = ({
  imageFileName,
  url,
  title,
  description,
  action,
  testId,
}: ValuePerpositionCardModel) => {
  const translate = useTranslate('item_verification.value_proposition')
  const isDarkMode = useIsDarkMode()
  const darkModeSuffix = isDarkMode ? '-dark' : ''
  const imageUrl = `${IMAGE_BASE_URL}/${imageFileName}${darkModeSuffix}`

  const { track } = useTracking()

  const handleOnAnchorClick = () => {
    track(
      clickEvent({
        screen: 'item_verification',
        target: 'hyperlink',
        targetDetails: `value_preposition_section__${url}`,
      }),
    )
  }

  return (
    <article className="item-verification__value-proposition-card" data-testid={testId}>
      <div className="item-verification__value-proposition-card-image">
        <Image
          src={`${imageUrl}.png`}
          srcset={`${imageUrl}.png 200w, ${imageUrl}@2x.png 400w`}
          sizes="200px"
          scaling="cover"
          loading="lazy"
        />
      </div>
      <h3 className="item-verification__value-proposition-card-title">{translate(title)}</h3>
      <p className="item-verification__value-proposition-card-description">
        {translate(description)}
      </p>
      <a
        className="item-verification__value-proposition-card-link"
        href={url}
        onClick={handleOnAnchorClick}
        data-testid={`${testId}-link`}
      >
        {translate(action)}
        <span className="item-verification__value-proposition-card-link-icon">
          <Icon name={ArrowRight16} />
        </span>
      </a>
    </article>
  )
}

export default Card
